import withAxios from '../utils/with-axios';
import { urls } from '../config';
import { prop } from 'ramda';
import getCursorPaginationParams from '../utils/getCursorPaginationParams';
var DEFAULT_PER_PAGE = 20;

/**
 * Get an order by ID
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id id of order to reference
 * @returns {Promise} Unresolved Promise from the API.
 */
function getOrderById($axios, id) {
  if (!id) throw new Error('Prop `id` is required in `orders.listOrders`');
  return $axios.get(urls.apiV2("/orders/".concat(id))).then(prop('data'));
}

/**
 * List all orders
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id id of order to reference
 * @param {Object} paginationOptions object containing pagination options
 * @returns {Promise} Unresolved Promise from the API.
 */
function listOrders($axios) {
  var paginationOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultParams = {
    use_pagination: true,
    limit: DEFAULT_PER_PAGE
  };
  var params = getCursorPaginationParams(paginationOptions, defaultParams);
  return $axios.get(urls.apiV2('/orders'), {
    params: params
  }).then(prop('data'));
}

/**
 * Create a new saved order
 * @param {Object} [$axios=axios] Axios instance.
 * @param {Object} order object to create the order
 * @returns {Promise} Unresolved Promise from the API.
 */
function createOrder($axios, order) {
  if (!order) {
    throw new Error('Prop {order} is required in `orders.createOrder`');
  }
  return $axios.post(urls.apiV2("/orders"), order).then(prop('data'));
}

/**
 * Updates a saved order
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Order ID to update
 * @param {Object} entity Data object to update the order
 * @returns {Promise} Unresolved Promise from the API.
 */
function updateOrder($axios, id, entity) {
  var replace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!id) {
    throw new Error('Prop `id` and `entity` are required for `orders.updateOrder`');
  }
  return $axios.put(urls.apiV2("/orders/".concat(id)), {
    entity: entity,
    replace: replace
  }).then(prop('data'));
}

/**
 * Deletes an order from the array by ID
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Order ID to update
 * @returns {Promise} Unresolved Promise from the API.
 */
function deleteOrder($axios, id) {
  if (!id) {
    throw new Error('Prop `id` is required in `orders.deleteOrder`');
  }
  return $axios.delete(urls.apiV2("/orders/".concat(id))).then(prop('data'));
}
export default {
  createOrder: withAxios(createOrder),
  getOrderById: withAxios(getOrderById),
  listOrders: withAxios(listOrders),
  updateOrder: withAxios(updateOrder),
  deleteOrder: withAxios(deleteOrder)
};